// extracted by css-extract-rspack-plugin
export default {"form":"tVXI78zMAPE7E1bw"};